import _typeof from "@babel/runtime/helpers/typeof";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { batch, batching } from 'redux-batch-middleware';
import thunk from 'redux-thunk';

function makeStore(reducers, history) {
  var middlewares = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var rootReducer = reducers.rootReducer,
      defaultReducers = reducers.defaultReducers;
  var middlewareList = [thunk, batch, routerMiddleware(history)].concat(_toConsumableArray(middlewares));
  var middlewareEnhancer = applyMiddleware.apply(void 0, _toConsumableArray(middlewareList));
  var enhancers = [middlewareEnhancer]; // If Redux DevTools Extension is installed use it, otherwise use Redux compose

  var composeEnhancers = process.env.NODE_ENV !== 'production' && (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
  var store = createStore(batching(rootReducer), composeEnhancers.apply(void 0, enhancers));
  store.asyncReducers = {};
  store.defaultReducers = defaultReducers;
  return store;
}

export default makeStore;